import { Stack } from "@mantine/core";
import type { DateTime } from "luxon";
import { EnergyRevenuesCellCheckStateColumn } from "../../../../types/api.types";
import { EnergyDataQuality } from "../../../EnergyData/EnergyDataQuality/EnergyDataQuality";
import type { EnergyRevenuesViewProps } from "../EnergyRevenuesView";
import { EnergyRevenuesView } from "../EnergyRevenuesView";
import { averageAvailablePercent } from "../utils/energyDataQuality/averageAvailablePercent";
import { calculateTotalVolume } from "../utils/energyDataQuality/calculateTotalVolume";
import { flattenMissingDataSources } from "../utils/energyDataQuality/flattenMissingDataSources";

const COLUMNS_WITH_VERIFICATION_ENABLED = [
  EnergyRevenuesCellCheckStateColumn.vermarktung_volume,
  EnergyRevenuesCellCheckStateColumn.vermarktung_net_revenue,
  EnergyRevenuesCellCheckStateColumn.vermarktung_fee,
  EnergyRevenuesCellCheckStateColumn.net_revenue_minus_fee,
  EnergyRevenuesCellCheckStateColumn.market_premium_volume,
  EnergyRevenuesCellCheckStateColumn.market_premium_revenue,
  EnergyRevenuesCellCheckStateColumn.ausfallarbeit_redispatch,
  EnergyRevenuesCellCheckStateColumn.ausfallarbeit_foerderung_redispatch,
  EnergyRevenuesCellCheckStateColumn.ausfallarbeit_dva,
  EnergyRevenuesCellCheckStateColumn.revenue_dva,
  EnergyRevenuesCellCheckStateColumn.revenue_redispatch,
  EnergyRevenuesCellCheckStateColumn.aufwandsersatz_redispatch,
  EnergyRevenuesCellCheckStateColumn.revenue_foerderung_redispatch,
  EnergyRevenuesCellCheckStateColumn.redispatch_entgelt,
  EnergyRevenuesCellCheckStateColumn.dva_entgelt
] satisfies Array<EnergyRevenuesCellCheckStateColumn>;

interface CompanySectionProps extends Omit<
  EnergyRevenuesViewProps,
  "dataVerificationColumns"
> {
  selectedDateRange: [DateTime<true>, DateTime<true> | null];
}

function CompanySection({
  energyRevenuesData,
  dataVerificationItems,
  companyId,
  exportFileName,
  selectedDateRange,
  isLoading
}: CompanySectionProps) {
  return (
    <Stack gap="md">
      <EnergyDataQuality
        isLoading={isLoading}
        missingDataSources={flattenMissingDataSources(energyRevenuesData)}
        qualityPercent={averageAvailablePercent(energyRevenuesData)}
        selectedDateRange={selectedDateRange}
        title="Tatsächliche Einspeisung"
        totalVolume={calculateTotalVolume(energyRevenuesData)}
      />
      <EnergyRevenuesView
        companyId={companyId}
        dataVerificationColumns={COLUMNS_WITH_VERIFICATION_ENABLED}
        dataVerificationItems={dataVerificationItems}
        energyRevenuesData={energyRevenuesData}
        exportFileName={exportFileName}
        isLoading={isLoading}
      />
    </Stack>
  );
}

export { CompanySection };
